import {request} from "@/api/request.js";

const analysis3={
    getAsmData(snv,tissue,healthStatus){
        return request.get(
            "/analysis/Prediction/ASM",
            {
                snv: snv,
                tissue: tissue,
                healthStatus: healthStatus
            }
        )
    },
    getGeneData(snv){
        return request.get(
            "/analysis/Prediction/gene",
            {
                snv: snv
            }
        )
    },
    getCellTypeData(snv,cellType){
        return request.get(
            "/analysis/Prediction/cellType",
            {
                snv: snv,
                cellType:cellType
            }
        )
    }
}

export default analysis3;
